import { RcClasses } from '../../../../foundation';
export var RcDragHandleClasses = RcClasses(['root'], 'RcDraggable');
